import React from "react";

const WhyChooseUs = () => {
  return (
    <section className="why">
      <div className="why__inner">
        <h1 className="why__title">Why choose us?</h1>

        {/* --- Panels from previous design --- */}
        <article className="why__panel">
          <div className="why__ribbon"><span>Expert Vocal Production:</span></div>
          <div className="why__body">
            <p>
              At Vocal Factory Global, we specialize in overdubs, vocal tracking
              and recording, vocal coaching and many more to ensure your voice
              is captured with clarity and precision. Whether you're new or
              experienced, we guide you through every step, focusing on the
              details that make your voice stand out. Using modern techniques,
              we create a polished sound that stays true to your unique style.
              Choose Vocal Factory Global for expert vocal production that
              elevates your music to the next level.
            </p>
          </div>
        </article>

        <article className="why__panel">
          <div className="why__ribbon why__ribbon--center">
            <span>
              Tailored Solutions for Every <br className="sm-hide" />
              Voice and Production/Project
            </span>
          </div>
          <div className="why__body">
            <p>
              At Vocal Factory Global, we believe every voice and project is unique.
              Hence, we customize our approach to meet your specific needs. For
              vocalists, we assess your strengths and goals to craft a plan that
              helps you refine pitch, tone, and stage presence.
            </p>
            <p>
              For projects, we tailor everything—background vocals, songwriting,
              overdubs, and arrangements—to match your vision. Our personalized
              approach ensures your talent and creativity shine through. At
              Vocal Factory Global, we create a mold that's perfect for you.
            </p>
          </div>
        </article>

        <article className="why__panel">
          <div className="why__ribbon"><span>Experienced Team:</span></div>
          <div className="why__body">
            <p>
              Our team brings years of experience and passion to every project.
              With expertise in vocal training, production, and performance
              across diverse styles, we're dedicated to helping you reach your
              musical goals. Our team adapts to your needs, offering both
              technical knowledge and mentorship to make each session productive
              and inspiring. Whether refining harmonies or preparing for live
              performances, we combine professionalism with a personal touch to
              ensure your success.
            </p>
          </div>
        </article>

        <article className="why__panel">
          <div className="why__ribbon"><span>Proven Track Record:</span></div>
          <div className="why__body">
            <p>
              Our results speak for themselves. We've worked with a wide range of
              clients, from aspiring singers to professionals, helping them
              overcome challenges and achieve their musical goals. From
              songwriting and vocal production to live vocal productions and
              overdubs, our services consistently exceed expectations. Clients
              return to us for our expertise and the impact we make on their
              growth and respective projects. Join the community of artists and
              teams who trust Vocal Factory Global to elevate their music.
            </p>
          </div>
        </article>

        <article className="why__panel">
          <div className="why__ribbon"><span>A Holistic Unique Experience:</span></div>
          <div className="why__body">
            <p>
              What sets us apart is the personal touch we bring to every client,
              crafting solutions that are as unique as you are. Plus, we make the
              production process fun, exciting, and engaging, ensuring every
              session is enjoyable. At Vocal Factory Global, it's not just about
              singing or music production—it's about unlocking your potential and
              enjoying the creative journey of your projects.
            </p>
          </div>
        </article>

        {/* --- New Pricing Section --- */}
        {/* <section className="pricing">
          <div className="pricing__block">
            <div className="pricing__header">Overdubs</div>

            <div className="pricing__row">
              <div className="pricing__desc">
                Per part per song <br />
                <small>(singles of no more than 8 minutes)</small>
              </div>
              <div className="pricing__price">Ghc500.00</div>
            </div>

            <hr className="pricing__divider" />

            <div className="pricing__row">
              <div className="pricing__desc">
                Per part per medley <br />
                <small>(medley of no more than 15 minutes)</small>
              </div>
              <div className="pricing__price">Ghc700.00</div>
            </div>
          </div>

          <div className="pricing__block">
            <div className="pricing__header">Vocal Stem</div>

            <div className="pricing__row">
              <div className="pricing__desc">
                Single of no more than 8 minutes <br />
                <small>4-day turnaround.</small>
              </div>
              <div className="pricing__price">Ghc1500.00</div>
            </div>

            <hr className="pricing__divider" />

            <div className="pricing__row">
              <div className="pricing__desc">
                Medley of no more than 15 minutes <br />
                <small>6-day turnaround.</small>
              </div>
              <div className="pricing__price">Ghc2100.00</div>
            </div>

            <div className="pricing__row">
              <div className="pricing__desc">
                 NB: All of the above, you are selecting your 
                    own well-equipped studio and sorting that 
                    out from your end. If you want us to use 
                    our own studio, amounts will be subject to change.
              </div>
            </div>

          </div>
        </section>

        <section className="pricing-section">
        <h2 className="section-title">BV Guide</h2>
        <div className="pricing-item">
          <p>Singles (singles of no more than 8 minutes)</p>
          <span className="price">Ghc550.00</span>
        </div>
        <hr />
        <div className="pricing-item">
          <p>Medleys (medley of no more than 15 minutes)</p>
          <span className="price">Ghc850.00</span>
        </div>

        <h2 className="section-title">Live BGVs</h2>
        <div className="pricing-item">
          <p>1,000ghc per gig per person</p>
          <span className="price">Ghc1000.00</span>
        </div>

        <h2 className="section-title">Vocal Scoring/Arrangement</h2>
        <p>Cost of taking care of the Music Director to 
            be decided by both parties upon discussing 
            the scale of work needed.</p>
      </section> */}

      </div>
    </section>
  );
};

export default WhyChooseUs;